export default {
  purchasing: {
    creditOrderTitle: 'Credit Order',
    creditOrderHelpIntro: 'To support Franchisees in scaling quickly',
    creditOrderReqTitle: '1. Order Requirements',
    creditOrderReqDesc: 'Franchisees can submit credit orders to the Master Franchisee',
    creditOrderFlowTitle: '2. Order Process',
    creditOrderFlowDesc1: 'The order becomes effective after approval by the Master Franchisee',
    creditOrderFlowDesc2: 'After shipment, the SN is transferred under the Franchisee account',
    addPurchase: '+ Add Purchase',
    initialPurchase: '+ Initial Purchase',
    payment: 'Payment',
    invoiceConfirm: 'Invoice Confirmation',
    changeAddress: 'Change Address',
    receiptConfirm: 'Receipt Confirmation',
    deliveryConfirm: 'Delivery Order Confirmation',
    cancel: 'Cancel',
    submit: 'Submit',
    invoiceConfirmTitle: 'Please confirm whether you have received the official invoice for this order amount',
    cancelOrderTip: 'Please confirm whether to cancel the order. Once canceled, the paid amount will be refunded to the corresponding Master Franchisee account and the credit limit will be adjusted accordingly',
    orderNo: 'Purchase Order Number',
    orderTime: 'Order Time',
    buyNum: 'Purchase Quantity',
    orderAmount: 'Order Amount',
    receivedAmount: 'Received Amount',
    received: 'Received',
    snMatch: 'Device SN matches the system',
    bothConfirm: '*Both confirmations are required',
    changeOrderAddress: 'Change Delivery Address',
    receiver: 'Recipient',
    receiverPhone: 'Recipient Phone Number',
    provinceCity: 'State / City / District',
    agentWarehouse: 'Master Franchisee Warehouse',
    address: 'Delivery Address',
    pleaseFillReceiver: 'Please enter recipient name',
    pleaseEnterReceiverPhone: 'Please enter recipient phone number',
    pleaseSelectProvince: 'Please select state / city / district',
    pleaseSelectWarehouse: 'Please select Master Franchisee warehouse',
    pleaseSelectAddress: 'Please select delivery address',
    pleaseEnterRemark: 'Please enter remarks (up to 200 characters)',
    productName: 'Product Name',
    discountAmount: 'Discount Amount',
    freightAmount: 'Prepaid Shipping Fee',
    payStatus: 'Payment Status',
    orderStatus: 'Order Status',
    productionStatus: 'Production Status',
    remark: 'Remarks',
    pleaseSelectProductionStatus: 'Please select production status',
    receiverMobile: 'Recipient Mobile Number',
    dispatchNum: 'Dispatched Quantity',
    dispatchType: 'Delivery Method',
    regionCampusId: 'Regional Master Franchisee ID',
    regionCampusName: 'Regional Master Franchisee Name',
    orderType: 'Order Type',
    purchaseType: 'Purchase Type',
    lastPayTime: 'Last Payment Time',
    to: 'To',
    dateRangeTilde: '~',
    submitter: 'Submitted By',
    submitTime: 'Submission Time',
    confirmTime: 'Confirmation Time',
    confirmBy: 'Confirmed By',
    creator: 'Created By',
    pleaseEnterOrderNo: 'Please enter purchase order number',
    pleaseSelectPerson: 'Please select person',
    pleaseSelectPayStatus: 'Please select payment status',
    pleaseEnterProductName: 'Please enter product name',
    pleaseSelectOrderStatus: 'Please select order status',
    pleaseSelectOrderType: 'Please select order type',
    pleaseSelectPurchaseTypeLabel: 'Please select purchase type',
    pleaseSelectDispatchType: 'Please select delivery method',
    receiverInfo: 'Recipient Information',
    pleaseEnterReceiverQuery: 'Please enter recipient name or phone number to search',
    invoiceType: 'Invoice Type',
    invoiced: 'Invoiced',
    notInvoiced: 'Not Invoiced',
    pleaseFillValidPhone: 'Please enter a valid phone number',
    pleaseSelectProvinceCity: 'Please select state / city / district',
    pleaseSelectAgentWarehouse: 'Please select Master Franchisee warehouse',
    pleaseFillAddress: 'Please enter delivery address',
    secondmentGoods: 'Stock Transfer',
    addRegionPurchase: '+ Regional Purchase',
    deductionPay: 'Deduction Payment',
    applicationNo: 'Application Number',
    applicantAgentId: 'Master Franchisee ID',
    applicantAgentName: 'Master Franchisee Name',
    totalAmount: 'Total Amount',
    voucherDeductionAmount: 'Voucher Deduction Amount',
    remainingAmount: 'Remaining Amount Due',
    transferNum: 'Transfer Quantity',
    detail: 'Details',
    confirmResult: 'Confirmation Result',
    agree: 'Approve',
    reject: 'Reject',
    confirmRemark: 'Confirmation Remarks',
    pleaseFillConfirmRemark: 'Please enter confirmation remarks',
    confirmPaymentReceivedTip: 'Please confirm the payment has been received before approving',
    confirmCancelTip: 'Are you sure you want to cancel?',
    voucherAccount: 'Fission Account',
    accountBalance: 'Account Balance',
    pleaseEnterContent: 'Please enter content',
    maxDeductible: 'Maximum Deductible Amount',
    yuan: '$',
    pleaseSelectConfirmResult: 'Please select confirmation result',
    paymentSuccess: 'Payment successful',
    orderWithRightsCannotEdit: 'This order includes benefits and cannot be modified. Please cancel the order before creating a new one',
    orderWithVoucherCannotCancel: 'This order includes returned vouchers and cannot be canceled',
    receivedAmountMinTip: 'The received amount must be at least 30% of the purchase amount before submitting for production',
    paySuccess: 'Payment successful',
    payFail: 'Payment failed',
    distributeSuccess: 'Distribution successful',
    confirmSuccess: 'Confirmation successful',
    confirmFail: 'Confirmation failed',
    cancelSuccess: 'Cancellation successful',
    cancelFail: 'Cancellation failed',
    modifySuccess: 'Update successful',
    modifyFail: 'Update failed',
    creditOrders: 'Credit Orders',
    creditOrderHelpTitle: 'To support Franchisees in scaling quickly',
    creditOrderHelpOrderReq: 'Order Requirements',
    creditOrderHelpOrderReqDesc: 'Franchisees can submit credit orders to the Master Franchisee',
    creditOrderHelpOrderFlow: 'Order Process',
    creditOrderHelpOrderFlowDesc1: 'The order becomes effective after approval by the Master Franchisee',
    addCreditOrder: '+ Add Credit Order',
    creditOrderNo: 'Credit Order Number',
    orderCreateTip: 'After creating the order, payment can be deferred or made partially. For details, please refer to:',
    viewDetail: 'View Details',
    provinceAudit: 'Regional Master Franchisee Review',
    auditResult: 'Review Result',
    auditRemark: 'Review Remarks',
    creditOrderConfirmTip: 'Please ensure the other party receives goods on credit and sells the devices before making payment',
    exemptionPay: 'Payment Exemption',
    paymentDeductionTip: 'This payment will deduct:',
    promotionFeeAccount: 'Promotion Fee Account',
    voucherBonusAccount: 'Voucher Bonus Account',
    cashAccount: 'Cash Account',
    goldAccount: 'Gold Account',
    deliveryVoucherAccount: 'Delivery Voucher Account',
    pleaseConfirmReceipt: 'Please confirm receipt has been completed',
    pleaseConfirmSnMatch: 'Please confirm the device SN matches the system',
    doubleOrder: 'Dual Order',
    addDoubleOrder: '+ Add Dual Order',
    sendDeliveryVoucher: 'Issue Delivery Voucher',
    distributeVoucherTip: 'Once the delivery voucher is issued in advance, this dual order cannot be modified. Please confirm to proceed',
    gotIt: 'Got It',
    paySuccessAmount: 'Payment of {symbol}{money}{unitSuffix} was successful',
    payFailAmount: 'Payment of {symbol}{money}{unitSuffix} failed',
    createTime: 'Created Time',
    orderNoSearch: 'Order Number',
    pleaseEnterOrderNoSearch: 'Please enter order number',
    agent: 'Master Franchisee',
    pleaseSelectAgent: 'Please select Master Franchisee',
    regionAgent: 'Regional Master Franchisee',
    pleaseSelectRegionAgent: 'Please select Regional Master Franchisee',
    status: 'Status',
    pleaseSelectStatus: 'Please select status',
    isVoucher: 'Voucher Deduction Applied',
    no: 'No',
    yes: 'Yes',
    pleaseSelectExemptionPay: 'Please select payment exemption option',
    relatedAgent: 'Associated Master Franchisee',
    relatedAgentId: 'Associated Master Franchisee ID',
    relatedAgentName: 'Associated Master Franchisee Name',
    pleaseSelectRelatedAgent: 'Please select associated Master Franchisee',
    actualPayAmount: 'Actual Payment Amount',
    purchaseUnit: 'Purchasing Unit',
    pleaseEnterReceiver: 'Please enter recipient name',
    phoneRequired: 'Phone number is required',
    pleaseSelectDispatch: 'Please select delivery method',
    pleaseEnterAddress: 'Please enter delivery address',
    pleaseEnterWarehouse: 'Please enter Master Franchisee warehouse',
    selectAddGoods: '+ Select Products',
    goodsDetail: 'Product Details',
    selectDiscount: '+ Select Discount',
    selectDiscountTitle: 'Select Discount',
    discountInfo: 'Discount Information',
    selectedVouchersAvailable: '{selected} selected / {total} available',
    vouchersAvailable: '{total} available',
    logisticsDetail: 'Logistics Details',
    productDetail: 'Product Details',
    sequenceNo: 'No.',
    orderProduct: 'Order Product',
    orderPendingSendNum: 'Pending Shipment Quantity',
    allocationDetailTable: 'Allocation Details',
    orderProductQty: 'Order Quantity',
    statisticsTime: 'Statistics Time',
    totalLabel: 'Total',
    deliveryQty: 'Delivery Quantity',
    creditOrderInterestTip: 'There is an interest margin on this credit order. Please pay {amount} to proceed to the next review stage.',
    paymentDetail: 'Payment Details',
    freightDetail: 'Prepaid Shipping Details',
    auditDetail: 'Review Details',
    priorityPurchaseRight: 'Eligible for "Priority Purchase of Limited Models"',
    discountRightRight: 'Eligible for "Purchase Price Discount"',
    originalPriceTotal: 'Original Total Price',
    saveAndPay: 'Save and Pay',
    addGoods: 'Add Products',
    inventoryStatusReminder: 'Inventory Status Reminder',
    inventoryStatusTip: 'The selected product is currently',
    inventoryStatusTip2: '. Delivery may take longer. You may go back to select other products or continue and wait for shipment',
    presale: 'Pre-order',
    outOfStock: 'Out of Stock',
    lowStock: 'Low Stock',
    inventoryEnough: 'In Stock',
    headquartersStopSale: 'Headquarters Sales Suspended',
    continueOrder: 'Continue Order',
    reselectGoods: 'Reselect Products',
    customDiscountAmount: 'Custom Discount Amount',
    pleaseEnterCustomDiscount: 'Please enter custom discount amount',
    headquartersDeliveryTip: 'For Demo Device, Subscription Cards, and accessories, please select [Headquarters Delivery]',
    changeToHeadquartersDelivery: 'Switch delivery method to [Headquarters Delivery]?',
    regionDeliveryTip: 'For Learning Tablet and other full-price products, please select [Regional Master Franchisee Delivery]',
    changeToRegionDelivery: 'Switch delivery method to [Regional Master Franchisee Delivery]?',
    limitedModelTip: 'For limited models, please select [Headquarters Delivery]',
    confirmDelete: 'Are you sure you want to delete?',
    pleaseEnterCampusAddress: 'Please enter Learning Center address',
    applicantAgent: 'Applicant Master Franchisee',
    deliveryRegionAgent: 'Receiving Regional Master Franchisee',
    selectDeliveryRegionAgent: 'Shipping Regional Master Franchisee',
    pleaseSelectDeliveryRegionAgent: 'Please select Regional Master Franchisee',
    isDoubleOrder: 'Dual Order',
    pleaseEnterAgentFilter: 'Please enter Master Franchisee ID or name to filter',
    payAmount: 'Payment Amount',
    operator: 'Operator',
    dispatchDate: 'Dispatch Date',
    expressCompany: 'Courier Company',
    expressNo: 'Tracking Number',
    logisticsStatus: 'Logistics Status',
    dispatchQty: 'Dispatched Quantity',
    chargeItem: 'Charge Item',
    unitPrice: 'Unit Price',
    quantity: 'Quantity',
    amount: 'Amount',
    rightName: 'Benefit Name',
    applicableProduct: 'Applicable Products',
    expiryTime: 'Expiration Time',
    rightCode: 'Benefit Code',
    paySerialNo: 'Payment Transaction ID',
    payMethod: 'Payment Method',
    payTime: 'Payment Time',
    auditTime: 'Review Time',
    auditByName: 'Reviewed By',
    auditByCampusId: 'Reviewer Master Franchisee ID',
    auditByCampusName: 'Reviewer Master Franchisee Name',
    pleaseSelectDeliveryRegionAgentRule: 'Please select Regional Master Franchisee',
    productManual: 'Product Manual',
    inventory: 'Inventory',
    view: 'View',
    suggestedRetailPrice: 'Suggested Retail Price: {symbol}{price}{unitSuffix}',
    discount: 'Discount',
    purchaseNo: 'Purchase Order Number',
    purchaseUnit: 'Purchasing Unit',
    creator: 'Created By',
    receiver: 'Recipient',
    receiverAddress: 'Receiver Address',
    receiverPhone: 'Recipient Phone Number',
    remark: 'Remarks',
    unitPrice: 'Unit Price',
    unitPricePlain: 'Unit Price',
    quantity: 'Quantity',
    quantityPlain: 'Quantity',
    customDiscount: 'Custom Discount Amount',
    discountAmountLabel: 'Discount Amount',
    purchaseAmount: 'Purchase Amount',
    cancel: 'Cancel',
    save: 'Save',
    saveSuccess: 'Saved successfully',
    performanceSplit: 'Performance Allocation',
    orderQty: 'Order Quantity',
    orderAmount: 'Order Amount',
    cashAmount: 'Cash Amount',
    contractManager: 'Contract Manager',
    tmkStaff: 'Telemarketing Staff',
    add: '+ Add',
    splitPerson: 'Allocated Person',
    pleaseSelectPerson: 'Please select person',
    filterKeyword: 'Enter keyword to filter',
    splitRatio: 'Allocation Ratio',
    splitAmount: 'Allocation Amount',
    delete: 'Delete',
    splitRatioTotal: 'Total Allocation Ratio',
    splitAmountTotal: 'Total Allocation Amount',
    fillCompleteTip: 'Please complete all fields in item {index}',
    splitSuccess: 'Allocation successful',
    splitFail: 'Allocation failed',
    returnFreight: 'Refund Shipping Fee',
    returnGoods: 'Return Goods',
    payment: 'Payment',
    orderTime: 'Order Time',
    purchaseQuantity: 'Purchase Quantity',
    actualPaymentAmount: 'Actual Payment Amount',
    shippingPlan: 'Shipping Plan',
    plan1: 'Option 1',
    plan2: 'Option 2',
    freightCollect: 'Freight Collect',
    freightCollectTip: 'Pay upon delivery',
    freightPrepay: 'Freight Prepaid',
    prepaidFreightTip: 'Pay at order placement',
    freightCollectTipLong: 'Payment is made to the courier upon delivery. The actual amount may vary by up to 20% and is subject to the final charge',
    prepaidFreightTipLong: 'Paid together with the order amount. Any disputes will be handled by headquarters',
    purchaseFeeNoticeTitle: 'If the order quantity is less than 10 units, freight is collected by default. To offer discounted shipping, a prepaid freight option is available. Please note:',
    purchaseFeeRule1: '1. Freight discounts follow the company agreement with JD Logistics. Current discount: 35% off. Updates will be announced if changed',
    purchaseFeeRule2: '2. Prepaid freight is optional. If not selected, freight must be paid to the courier upon delivery based on the courier’s actual charge',
    purchaseFeeRule3: '3. If prepaid freight is collected and the order is later combined with others to qualify for free shipping (≥10 units), the prepaid freight will be refunded automatically',
    originalPrice: 'Original Price',
    purchaseQty: 'Purchase Quantity',
    units: 'Units',
    unitPiece: 'Pieces',
    paidAmount: 'Paid Amount',
    freightIncluded: 'Shipping Included',
    procurementAgentBalance: 'Master Franchisee Balance',
    relatedAgentAccountBalance: 'Associated Master Franchisee Account Balance',
    promoteAccount: 'Promotion Account',
    paymentMethod: 'Payment Method',
    pleaseSelectPaymentMethod: 'Please select a payment method',
    corporateTransfer: 'Corporate Transfer',
    pay: 'Pay',
    voucherBonusAccount: 'Voucher Bonus Account',
    cashAccount: 'Cash Account',
    accountBalance: 'Account Balance',
    availableAmount: 'Available Amount',
    otherAmount: 'Other Amount',
    paymentTitle: 'Purchase Payment',
    interestSpreadAmount: 'Interest Margin Amount',
    voucherCashNotZero: 'Voucher Bonus Account and Cash Account cannot both be 0. Please revise',
    paySuccess: 'Payment successful',
    payFail: 'Payment failed',
    drawInvoice: 'Issue Invoice',
    invoiceType: 'Invoice Type',
    pleaseSelectInvoiceType: 'Please select invoice type',
    sendEmail: 'Email Address',
    pleaseEnterEmail: 'Please enter email address',
    invalidEmailFormat: 'Invalid email format',
    deviceAmount: 'Device Amount',
    pleaseEnterDeviceAmount: 'Please enter device amount',
    softwareAmount: 'Software Amount',
    pleaseEnterSoftwareAmount: 'Please enter software amount',
    invalidNumberFormat: 'Invalid format. Please enter a number',
    amountNotNegative: 'Amount cannot be less than 0',
    recalcAmount: 'Recalculate Amount',
    total: 'Total:',
    invoiceSuccess: 'Invoice issued successfully',
    invoiceFail: 'Invoice issuance failed',
    fillError: 'Input Error',
    batchImport: 'Batch Import',
    uploadDoc: 'Upload Document',
    dataValidate: 'Data Validation',
    importData: 'Import Data',
    complete: 'Completed',
    batchImportTip1: '1. Do not modify the header names or purchase order information in the template. Do not delete the header row',
    batchImportTip2: '2. For multiple devices under one purchase order, duplicate the order information and record each device in a separate row',
    batchImportTip3: '3. Purchase Order ID and Purchase Order Number are used as unique identifiers',
    batchImportTip4: '4. The import file must not exceed 1,000 rows',
    selectImportFile: 'Select a file to import and start the process',
    clickUpload: 'Click to upload',
    dataValidating: 'Validating data, please wait',
    dataValidateComplete: 'Data validation complete. Total',
    orderInfo: 'order records',
    errorCount: 'error(s)',
    fixAndRetry: 'Please fix and try again',
    errorDetailDownload: 'Download the file to view detailed error information',
    errorDetailDownloadTip: 'Download the file to view detailed error information',
    importing: 'Data is being imported. You may close this page; the process will complete automatically',
    importComplete: 'Import completed',
    importDetail: 'Import Details',
    upload: 'Upload',
    confirmImport: 'Confirm import',
    onlyXlsFormat: 'Only .xls format is supported',
    noValidData: 'No valid data found for import',
    partialErrorImport: 'Some data contains errors. If you proceed, invalid data will not be imported',
    submitSuccess: 'Submitted successfully',
    submitFail: 'Submission failed',
    pleaseSelectAgentWarehouseAddr: 'Please select Master Franchisee warehouse',
    pleaseSelectDeliveryAddress: 'Please select delivery address',
    deleteSuccess: 'Deleted successfully',
    pleaseSelectGoodsFirst: 'Please select products first',
    pleaseEnterValidPhoneNum: 'Please enter a valid phone number',
    pleaseEnterDetailAddress: 'Please enter a detailed delivery address (e.g., street, district, city, province)',
    pleaseAddGoodsQty: 'Please enter product quantity',
    pleaseSelectPurchaseType: 'Please select purchase type first',
    provinceAgentNoCredit: 'Regional Master Franchisee cannot place credit orders. Please use standard online orders instead',
    notSameEntityNoCredit: 'You and the upstream Master Franchisee are not under the same entity. Credit orders are not allowed. Please use standard online orders',
    referralRewardStageNoCredit: 'You are currently in the referral reward stage. Please place orders through standard online orders with your referrer',
    onlyDealerCredit: 'Only Franchisees can apply for credit orders. As a Master Franchisee, please use standard online orders',
    queryFail: 'Query failed',
    saveSuccessExclamation: 'Saved successfully',
    saveCancelled: 'Save canceled',
    purchaseNoLabel: 'Purchase Order Number:',
    pleaseEnterPurchaseNo: 'Please enter purchase order number',
    agentLabel: 'Master Franchisee:',
    orderStatusLabel: 'Order Status:',
    pleaseSelectOrderStatus: 'Please select order status',
    payStatusLabel: 'Payment Status:',
    pleaseSelectPayStatus: 'Please select payment status',
    orderTimeLabel: 'Order Date',
    productNameLabel: 'Product Name:',
    pleaseEnterProductName: 'Please enter product name',
    purchaseQtyLabel: 'Purchase Quantity:',
    purchaseAmountLabel: 'Purchase Amount:',
    paidAmountLabel: 'Paid Amount:',
    submitterLabel: 'Submitted By:',
    pleaseSelectSubmitter: 'Please select submitter',
    orderTypeLabel: 'Order Type:',
    pleaseSelectOrderType: 'Please select order type',
    receiverInfoLabel: 'Recipient Information:',
    pleaseEnterReceiverQuery: 'Please enter recipient name or phone number to search',
    isSplitLabel: 'Performance Allocated:',
    pleaseSelectIsSplit: 'Please select allocation status',
    dispatchTypeLabel: 'Delivery Method:',
    pleaseSelectDispatchType: 'Please select delivery method',
    remarkLabel: 'Remarks:',
    remarkPlaceholder: 'Please enter remarks',
    isInvoiceLabel: 'Invoice Issued:',
    pleaseSelectInvoice: 'Please select invoice option',
    pleaseSelectProductType: 'Please select product type',
    contractAgentLabel: 'Contracted Master Franchisee:',
    tmallOrderNoLabel: 'Tmall Order Number:',
    pleaseEnterTmallOrderNo: 'Please enter Tmall order number',
    agentWarehouseLabel: 'Master Franchisee JD Warehouse:',
    pleaseEnterAgentWarehouse: 'Please enter Master Franchisee JD warehouse',
    isDualOrderLabel: 'Dual Order:',
    pleaseSelectIsDualOrder: 'Please select dual order option',
    relatedAgentLabel: 'Associated Master Franchisee:',
    pleaseSelectRelatedAgent: 'Please select associated Master Franchisee',
    tmallOrderNoCol: 'Tmall Order Number',
    agentWarehouseNameCol: 'Master Franchisee JD Warehouse',
    dualCampusIdLabel: 'Associated Master Franchisee ID',
    dualCampusNameLabel: 'Associated Master Franchisee Name',
    addHierarchyRelation: '+ Add Hierarchy Relationship',
    editHierarchyRelation: 'Edit Hierarchy Relationship',
    superiorAgent: 'Superior Master Franchisee',
    subordinateAgent: 'Subordinate Master Franchisee',
    pleaseSelectSuperiorAgent: 'Please select upstream Master Franchisee',
    pleaseSelectSubordinateAgent: 'Please select downstream Master Franchisee',
    isSendGood: 'Shipment Required',
    pleaseSelectIsSendGood: 'Please select shipment option',
    subAgentRegion: 'Downstream Master Franchisee Region',
    superiorAgentId: 'Upstream Master Franchisee ID',
    superiorAgentName: 'Upstream Master Franchisee Name',
    agentType: 'Master Franchisee Type',
    subordinateAgentId: 'Downstream Master Franchisee ID',
    subordinateAgentName: 'Downstream Master Franchisee Name',
    tip: 'Notice',
    editSuccess: 'Updated successfully',
    editFail: 'Update failed',
    deleteOrderConfirmTip: 'Please confirm whether to cancel the order. Once canceled, the paid amount will be refunded to the corresponding Master Franchisee account and credit limits will be adjusted accordingly',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    deleteSuccess: 'Deleted successfully',
    deleteFail: 'Delete failed',
    hierarchyYes: 'Yes',
    hierarchyNo: 'No',
    outboundRecordImport: 'Outbound Record Import',
    stockOutDetail: 'Stock Out Details',
    stockInRecord: 'Production Stock In',
    snCodeUpload: 'SN Code Upload',
    confirmCancelStockOut: 'Are you sure you want to cancel stock out?',
    stockOutWarehouse: 'Stock Out Warehouse',
    pleaseSelectStockOutWarehouse: 'Please select stock out warehouse',
    stockOutType: 'Stock Out Method',
    pleaseSelectStockOutType: 'Please select stock out method',
    stockOutTime: 'Stock Out Time',
    operationTime: 'Operation Time',
    pleaseEnterLogisticsNo: 'Please enter tracking number',
    relatedOrderNo: 'Related Order Number',
    pleaseEnterRelatedOrderNo: 'Please enter related order number',
    agentId: 'Master Franchisee ID',
    agentName: 'Master Franchisee Name',
    deviceSN: 'Device SN',
    logisticsCompany: 'Logistics Method',
    operator: 'Operator',
    invalid: 'Invalid',
    valid: 'Valid',
    stockInNo: 'Stock In Number',
    pleaseEnterStockInNo: 'Please enter stock in number',
    stockInWarehouse: 'Stock In Warehouse',
    pleaseSelectStockInWarehouse: 'Please select stock in warehouse',
    stockInType: 'Stock In Type',
    pleaseSelectStockInType: 'Please select stock in type',
    stockInTime: 'Stock In Time',
    stockInStatus: 'Stock In Status',
    pleaseSelectStockInStatus: 'Please select stock in status',
    creator: 'Created By',
    stockInNum: 'Stock In Quantity',
    actualStockInNum: 'Actual Stock In Quantity',
    stockInProduct: 'Stock In Product',
    pleaseSelectStockInProduct: 'Please select stock in product',
    pleaseEnterStockInNum: 'Please enter stock in quantity',
    pleaseEnterRemark200: 'Please enter remarks (up to 200 characters)',
    pleaseSelectDate: 'Please select date',
    uploadDoc: 'Upload Document',
    dataValidate: 'Data Validation',
    importData: 'Import Data',
    complete: 'Completed',
    templateHeaderTip: 'Do not modify header names or purchase order information in the template. Do not delete the header row',
    selectFileToImport: 'Select a file to import and start the process',
    dataValidating: 'Validating data, please wait',
    dataRetrieveComplete: 'Data retrieval complete. Total',
    orderInfoCount: 'order records',
    errorInfoCount: 'Error Details',
    correctAndRetry: 'records. Please correct and try again',
    errorDetailDownload: 'Download the file to view detailed error information',
    errorInfoXls: 'Error Details.xls',
    importingDataTip: 'Data is being imported. You may close this page, and the system will complete the process automatically',
    importComplete: 'Import completed',
    confirmImport: 'Confirm import',
    dragFileTip: 'Drag files here, or',
    clickUpload: 'Click to upload',
    upload: 'Upload',
    confirmCancelLading: 'Are you sure you want to cancel the delivery order?',
    confirmCancelTransferOrder: 'Are you sure you want to cancel the transfer order?',
    reviewTransferOrder: 'Review Transfer Order',
    transferOrderNo: 'Transfer Order Number',
    transferOutInfo: 'Transfer Out Information',
    transferInInfo: 'Transfer In Information',
    transferOutAgent: 'Transfer Out Master Franchisee',
    transferOutAgentName: 'Transfer Out Master Franchisee Name',
    transferOutWarehouse: 'Transfer Out Warehouse',
    transferInAgent: 'Transfer In Master Franchisee',
    transferInAgentName: 'Transfer In Master Franchisee Name',
    transferInWarehouse: 'Transfer In Warehouse',
    productInfo: 'Product Information',
    transferNum: 'Transfer Quantity',
    reject: 'Reject',
    agree: 'Approve',
    allocationForecast: 'Allocation Forecast',
    viewDetail: 'View Details',
    ladingNo: 'Delivery Order Number',
    pleaseEnterLadingNo: 'Please enter delivery order number',
    jdProductName: 'JD Product Name',
    pleaseEnterJdProductName: 'Please enter JD product name',
    sendStatus: 'Shipment Status',
    pleaseSelectSendStatus: 'Please select shipment status',
    sendTime: 'Shipment Time',
    shipWarehouse: 'Shipping Warehouse',
    pleaseSelectShipWarehouse: 'Please select shipping warehouse',
    relatedOrder: 'Related Order',
    pleaseEnterRelatedOrder: 'Please enter related order',
    wayBillNo: 'Tracking Number',
    pleaseEnterWayBillNo: 'Please enter tracking number',
    shipRegionAgentName: 'Shipping Regional Master Franchisee Name',
    pleaseSelectShipRegionAgentName: 'Please select shipping Regional Master Franchisee',
    waitSendNum: 'Pending Shipment Quantity',
    receiverAddress: 'Receiver Address',
    sendNum: 'Shipped Quantity',
    logisticsNo: 'Tracking Number',
    logisticsNoLabel: 'Tracking Number:',
    tkOrderNo: 'Transfer Order Number',
    pleaseEnterTkOrderNo: 'Please enter transfer order number',
    targetWarehouse: 'Target Warehouse',
    pleaseEnterTargetWarehouse: 'Please enter target warehouse',
    warehouseTransferStatus: 'Warehouse Transfer Status',
    pleaseSelectWarehouseTransferStatus: 'Please select status',
    relatedTransferOrder: 'Related Transfer Order',
    pleaseEnterRelatedTransferOrder: 'Please enter related transfer order',
    cloudWarehouseTransferNo: 'Cloud Warehouse Transfer Order Number',
    pleaseEnterCloudWarehouseTransferNo: 'Please enter cloud warehouse transfer order number',
    transferInAgentId: 'Transfer In Master Franchisee ID',
    transferInAgentName: 'Transfer In Master Franchisee Name',
    transferOutAgentId: 'Transfer Out Master Franchisee ID',
    transferOutAgentName: 'Transfer Out Master Franchisee Name',
    tkNum: 'Transfer Quantity',
    tkNumSent: 'Transferred Quantity',
    productType: 'Product Type',
    pleaseSelectProductType: 'Please select product type',
    allocationType: 'Allocation Type',
    pleaseSelectAllocationType: 'Please select allocation type',
    pendingOrderAllocation: 'Pending Order Allocation',
    orderWeightAllocation: 'Order Weight Allocation',
    allocationNum: 'Allocated Quantity',
    outOfStockNum: 'Out of Stock Quantity',
    availableStock: 'Available Inventory',
    systemWeight: 'System Weight (%)',
    systemAllocation: 'System Allocation',
    manualAllocation: 'Manual Allocation',
    saleShipmentExport: 'Sales Shipment Export',
    allocationListExport: 'Allocation List Export',
    warehouseOutDetailExport: 'Stock Out Details Export',
    warehouseInDetailExport: 'Stock In Details Export',
    productionStockExport: 'Production Stock In Export',
    pleaseEnterRelationNo: 'Please enter related order number',
    pleaseSelectStockType: 'Please select stock in type',
    pleaseSelectStockGoods: 'Please select stock in product',
    pleaseSelectStockWarehouse: 'Please select stock in warehouse',
    pleaseSelectStockNum: 'Please select stock in quantity',
    pleaseSelectStockTime: 'Please select stock in time',
    createSuccess: 'Created successfully',
    addStockTitle: 'Add Stock In Order',
    editStockTitle: 'Edit Stock In Order',
    importDataErrorTitle: 'Warning: Data errors remain',
    importDataErrorContent: 'Some data contains errors. If you proceed, invalid data will not be imported into the system',
    jdTransferOrderExport: 'JD Transfer Order Export',
    audit: 'Review',
    pendingAudit: 'Pending Review',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    audited: 'Reviewed',
    statusNew: 'New',
    statusInitial: 'Initial',
    statusCancelSuccess: 'Cancellation successful',
    statusGenFailed: 'Generation failed',
    confirmCancelStockIn: 'Are you sure you want to cancel stock in?',
    vendorName: 'Vendor',
    pleaseEnterVendorName: 'Please enter vendor name',
    stockInStatusIn: 'Stock In Completed',
    stockInStatusOut: 'Stock Out Completed',
    snCodePlaceholder: 'Please enter SN code',
    addProductRatio: 'Add Product Ratio',
    autoOrderConfigTitle: 'Auto Order Product Ratio Configuration',
    agentIdLabel: 'Master Franchisee ID:',
    ratioTip: '*Please ensure accurate ratios for each model. Orders will be allocated based on these ratios. The total must equal 100%',
    productModel: 'Product Model',
    ratioWithTotal: 'Ratio (Total {n}%)',
    pleaseEnterRatio: 'Please enter ratio',
    updateLog: 'Update Log:',
    ratioValidationError: 'Please enter valid ratios: integers from 1 to 100, with a total of 100%',
    autoOrderSaveSuccess: 'Saved successfully',
    autoOrderSaveFailed: 'Save failed',
    agentIdCol: 'Master Franchisee ID',
    agentNameCol: 'Master Franchisee Name',
    productModelCol: 'Product Model',
    productStatusCol: 'Product Status',
    productRatioCol: 'Product Ratio (Total = 100)',
    lastUpdateTime: 'Last Updated Time',
    lastUpdateBy: 'Last Updated By',
    createByCol: 'Created By',
    edit: 'Edit',
    detail: 'Details',
    onlyXlsXlsx: 'Only .xls and .xlsx files are supported',
    noValidUploadData: 'No valid data to upload',
    createFailed: 'Creation failed',
    auditSuccess: 'Review successful',
    rejectSuccess: 'Rejection successful',
    auditFailed: 'Review failed',
    rejectFailed: 'Rejection failed',
    warehouse: 'Warehouse',
    pleaseSelectWarehouseForAllocation: 'Please select warehouse',
    timeLabel: 'Time',
    suggestSufficientStock: 'Recommended when inventory is sufficient',
    allocate: 'Allocate',
    saveData: 'Save Data',
    confirmSavePreallocation: 'Do you want to save this pre-allocation data?',
    warehouseName: 'Warehouse Name',
    currentPendingOrder: 'Current Pending Shipment Orders',
    allocationSendGoodsNum: 'Allocated Pending Shipment Orders',
    productOrderNum: 'Product Order Quantity',
  }
}
